// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import logo from "./assets/images/Logo/Hazar-terra-leaf.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`px-4 md:px-2 py-4 md:pt-3 md:pb-2 md:p-4 transition-shadow ease-in-out duration-500 rounded-b-3xl ${isScrolled ? 'bg-white shadow-lg' : ''}`}>
      <div className="container mx-auto flex justify-between items-center">
        <img src={logo} alt='1' className='h-20 w-auto' />
        
        {/* Menu pour les écrans plus grands */}
        <div className="hidden md:flex space-x-9">
          <a href="#home" className="text-gray-700">Home</a>
          <a href="#about" className="text-gray-700e">À propos</a>
          <a href="#products" className="text-gray-700">Produits</a>
          <a href="#contact" className="text-gray-700">Contact</a>
        </div>

        {/* Hamburger pour les petits écrans */}
        <button onClick={toggleMenu} className="md:hidden text-[#6BA368] pr-4">
          Menu
        </button>
      </div>

      {/* Menu mobile */}
      <div className={`md:hidden ${isOpen ? "max-h-screen opacity-100 visible bg-[#6BA368] text-white p-4 mt-4 rounded-2xl transition-all ease-in-out duration-300" : "max-h-0 opacity-0 invisible"} transition-all ease-in-out duration-300`}>
        <a href="#home" className="block py-2">Home</a>
        <a href="#about" className="block py-2">À propos</a>
        <a href="#products" className="block py-2">Produits</a>
        <a href="#contact" className="block py-2">Contact</a>
      </div>
    </nav>
  );
};

export default Navbar;